import $ from "jquery";
import store from "../store";
import { updateToastData } from "@features/toastSlice";
import { updateActionModal } from "@features/modalSlice";
import { sendRequest } from "./retrieve-data";
import {
    IFilters,
    IRulesData,
    ParentModule,
    TModalConfig,
} from "./common-types";
import { getActiveModule } from "./utils";
let isEditMode = false;

function toggleFreqMode(force: string, modalId: string) {
    const next =
        (typeof force === "string" ? force : null) ||
        $(`#${modalId} #freq-mode`).text();
    const toShow = next === "Basic" ? ".frequency" : ".cron";
    const toHide = next === "Basic" ? ".cron" : ".frequency";
    $(`#${modalId} #freq-mode`)
        .attr("data-mode", next)
        .text(next === "Basic" ? "Advanced" : "Basic");
    $(`#${modalId} ${toHide}`).hide();
    $(`#${modalId} ${toShow}`).show();
    $(`#${modalId} #freq-label`).text(
        next === "Basic" ? "Frequency" : "CRON String"
    );
}

export function showModalHandler(
    modalId: string,
    config: TModalConfig,
    onsavefn?: (data: IRulesData) => void
) {
    toggleButtonLoader("", false, "saveChanges");
    isEditMode = config.isEdit || false;
    if (isEditMode) {
        store.dispatch(updateActionModal(true));
    }
    saveActionHandle(modalId, config, isEditMode ? onsavefn : null);
    toggleFreqMode("Basic", modalId);
}

export const toggleButtonLoader = (
    ruleId: string,
    isEdit: boolean,
    btnType?: string
) => {
    const actionModalDisp = store.getState().actionModalDisp.value;
    if (isEdit && !actionModalDisp) {
        $(`#edit-btn-${ruleId},#edit-loader-${ruleId}`).toggle();
    } else {
        switch (btnType) {
            case "action":
                $(`#action-btn-${ruleId},#action-loader-${ruleId}`).toggle();
                break;
            case "archive":
                $(`#archive-btn-${ruleId},#archive-loader-${ruleId}`).toggle();
                break;
            case "saveChanges":
                $("#save-btn-rules,#save-loader-rules").toggle();
                break;
        }
    }
};

export async function saveActionHandle(
    modelId: string,
    config: TModalConfig,
    onsave: (data: IRulesData) => void
) {
    try {
        const { result, data } = await saveActionsHandler(
            modelId,
            config.rule_id,
            config.filter,
            config.module
        );

        if (!result.status) {
            throw new Error(result.message);
        }

        showToast("success", result.message);
        store.dispatch(updateActionModal(false));
        onsave && onsave(data as IRulesData);
    } catch (err) {
        // showModalValidation(err.message, modalId);
        console.error(err);
        const resErrMsg = (err as Error).message;
        showToast(
            "danger",
            `Rule could not be saved.` + `${resErrMsg && ": " + resErrMsg}`
        );
    }
    toggleButtonLoader(config.rule_id, config.isEdit);
}

export function clearModal(modalId: string) {
    // Ensure the selector has # prefix if it's an ID
    const selector = modalId.startsWith("#") ? modalId : `#${modalId}`;
    const $modal = $(selector);

    // Check if the element exists
    if ($modal.length === 0) {
        return; // Element doesn't exist, nothing to do
    }

    // Check if modal is already hidden
    if (!$modal.hasClass("show") && $(".modal-backdrop").length === 0) {
        return; // Already hidden, nothing to do
    }

    try {
        // Check if Bootstrap Modal is initialized on this element
        // Bootstrap 5 uses "bs.modal", Bootstrap 4 uses "modal"
        const modalInstance = $modal.data("bs.modal") || $modal.data("modal");

        if (modalInstance && typeof modalInstance.hide === "function") {
            // Modal is properly initialized, use Bootstrap's hide method
            $modal.modal("hide");
        } else {
            // If modal is not initialized, manually clean up
            $modal.hide();
            $modal.removeClass("show");
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open");
            $("body").css("padding-right", "");
        }
    } catch (error) {
        // Fallback: manually hide the modal and clean up backdrop
        // This prevents the "Cannot read properties of undefined (reading 'backdrop')" error
        console.warn(`Error hiding modal ${modalId}:`, error);
        $modal.hide();
        $modal.removeClass("show");
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
        $("body").css("padding-right", "");
    }
}

export async function saveAction(
    type: string,
    actionObject: IRulesData,
    ruleId = ""
) {
    const { filters } = actionObject;
    delete actionObject["client"];
    const { activeModule } = getActiveModule();

    if (type === "query") {
        delete actionObject["action"];
        delete actionObject["frequency"];
    }
    try {
        const response = await sendRequest({
            type: `rules${ruleId ? `/${type}/${ruleId}` : ""}`,
            data: {
                ...actionObject,

                // For rules edit error was throw if stringified data was sent
                filters:
                    activeModule === ParentModule.RULES
                        ? filters
                        : JSON.stringify(filters),
                type,
            },
            method: ruleId ? "put" : "post",
        });
        if (!response.status) {
            throw new Error(response.message);
        }
        toggleButtonLoader("", false, "saveChanges");
        return { data: { ...actionObject, type }, result: response };
    } catch (err: any) {
        console.error(err);
        toggleButtonLoader("", false, "saveChanges");
        return {
            result: {
                status: false,
                message: err.message,
            },
        };
    }
}

export function saveActionsHandler(
    modalId: string,
    ruleId: string,
    filters: Record<string, IFilters>,
    module: string
) {
    const modalElem = `#${modalId}`;
    const actionType = $(modalElem)
        .find("input[name='actions']:checked")
        .val()
        .toString();
    const actionValue = $(modalElem)
        .find("select#action-type")
        ?.val()
        ?.toString();

    const actionObject = {
        filters,
        name: ($(modalElem).find("input#action-name").val() as string) || null,
        module,
        description: $(modalElem).find("#action-description").val(),
        ...(actionType === "rule" && {
            action: {
                type: actionValue || undefined,
                value:
                    parseInt(
                        $(modalElem).find("input#action-value").val() as string,
                        10
                    ) || undefined,
            },
            frequency: {
                value:
                    parseInt(
                        $(modalElem)
                            .find("input#frequency-value")
                            .val() as string,
                        10
                    ) || null,
                unit:
                    ($(modalElem)
                        .find("select#frequency-units")
                        .val() as string) || null,
            },
            cronString:
                ($(modalElem).find("input#cron_string").val() as string) ||
                null,
            excludeYesterday: !!$(modalElem).find("input#exclude:checked")
                .length,
            ...(actionValue === "percentIncrease"
                ? {
                      threshold: {
                          max: parseInt(
                              $(modalElem)
                                  .find("input[name='max_value']")
                                  .val() as string,
                              10
                          ),
                      },
                  }
                : actionValue === "percentDecrease"
                ? {
                      threshold: {
                          min: parseInt(
                              $(modalElem)
                                  .find("input[name='min_value']")
                                  .val() as string,
                              10
                          ),
                      },
                  }
                : null),
        }),
    };

    /** Delete Extras */
    if (
        actionObject.frequency &&
        !(actionObject.frequency.unit && actionObject.frequency.value)
    )
        delete actionObject.frequency;
    return saveAction(actionType, actionObject, ruleId);
}

export function showToast(type: string, text: string) {
    store.dispatch(
        updateToastData({
            type: type,
            text: text,
            show: true,
        })
    );
}

// function showModalAlert(modalId, type, message) {
// 	$(`#${modalId} .alert-panel`)
// 		.removeClass("alert-danger alert-success")
// 		.addClass(`alert-${type}`)
// 		.show()
// 		.text(message);
// }

// function hideModalAlert(modalId) {
// 	$(`#${modalId} .alert-panel`).hide();
// }

// export async function actionTypeWhileSavingRuleChangeHandler(event, modalId) {
// 	const actionType = $(this).val();
// 	showModalLoader(modalId);
// 	if (!isEditMode) {
// 		const existingRule = await getRuleByFilter(
// 			sessionStorage.getItem("appliedFilters")
// 		);
// 		if (existingRule.exists) {
// 			showActionWarningComponent(actionType, existingRule.rules[0]);
// 		} else {
// 			showActionConfigurationComponent(actionType);
// 		}
// 	} else {
// 		showActionConfigurationComponent(actionType);
// 	}

// 	hideModalAlert(modalId);
// 	hideModalLoader(modalId);
// }

function showActionConfigurationComponent(actionType: string) {
    $("#existing-action-warning").hide();
    $("#action-configuration").show();
    const targetBox = $(`.${actionType}`);
    $(".box").not(targetBox).hide();
    $(targetBox).show();
}

// function showActionWarningComponent(actionType, rule) {
// 	$("#action-configuration").hide();
// 	$("#existing-action-warning").show();
// 	const warningMessage = `
// 		A rule is already saved with "${rule.name}". Are you sure you want to add a new rule with this selection? click here to view the rule
// 	`;
// 	$("#warning-message").text(warningMessage);
// }

export function bypassWarningHandler() {
    showActionConfigurationComponent("rule");
}

// function showModalValidation(errors, modalId) {
// 	// $(`#${modalId} .needs-validation`).addClass('was-validated')
// 	if (errors instanceof Array)
// 		errors.forEach(({ instancePath, message }) => {
// 			if (instancePath) {
// 				//document.querySelector(`#${modalId} [data-instance-path="${instancePath}"]`).setCustomValidity(message)
// 				showToast(
// 					"danger",
// 					`${instancePath.slice(1).replaceAll("/", ".")} - ${message}`
// 				);
// 			} else {
// 				showModalAlert(modalId, "danger", message);
// 			}
// 		});
// 	else if (typeof errors == "string")
// 		showModalAlert(modalId, "danger", errors);
// }
